import { Clickable } from 'src/shared/design-system/Utilities';
import styled from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';
import { DASHBOARD_MAX_WIDTH_BREAKPOINT, PAGE_HEADER_HEIGHT, PAGE_MENU_BUTTON_SIZE } from '../consts';

export const Container = styled.div`
  align-items: center;
  background: ${Colors.WHITE};
  border-bottom: ${Border.Base} ${Colors.GRAY_LITE_20};
  display: flex;
  height: ${PAGE_HEADER_HEIGHT}px;
  margin: -${Spacing.SINGLE_HALF} -${Spacing.SINGLE_HALF} ${Spacing.SINGLE_HALF} -${Spacing.SINGLE_HALF};

  ${Mixins.Media.maxWidthSmall(`
    margin: -${PAGE_HEADER_HEIGHT}px 0px ${Spacing.SINGLE} 0px;
    ${Mixins.Border.setTopSide(Border.Radius.M)}
  `)}

  @media (min-width: ${DASHBOARD_MAX_WIDTH_BREAKPOINT}px) {
    ${Mixins.Border.setTopSide(Border.Radius.M)}
  }
`;

export const Header = styled.h1`
  color: ${Colors.RADISH};
  padding: 0 ${Spacing.THREE_QUARTERS};
  margin: 0 0 0 ${Spacing.THREE_QUARTERS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  ${Font.bySize(Font.Size.M)}

  ${Mixins.Media.maxWidthSmall(`
    margin: 0;
  `)}
`;

export const SubHeader = styled.div`
  color: ${Colors.GRAY_DARK_10};
  ${Font.bySize(Font.Size.XS)}
`;

export const TopNavButton = styled(Clickable)`
  background: transparent;
  height: ${PAGE_MENU_BUTTON_SIZE}px !important;
  width: ${PAGE_MENU_BUTTON_SIZE}px !important;
  padding: 0 !important;
  top: ${Spacing.EIGHTH};

  & svg {
    color: ${Colors.GRAY_DARK_10};
    height: ${PAGE_MENU_BUTTON_SIZE}px;
    width: ${PAGE_MENU_BUTTON_SIZE}px;
    padding: ${Spacing.QUARTER};
  }

  ${Mixins.Media.maxWidthSmall(`
    display: block;
  `)}
  ${Mixins.Media.minWidthSmall(`
    display: none;
  `)}
`;
